<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-people"></i>
                            <span>{{studentName}}</span>
                        </h2>
                    </div>
                    <div class="panel__body">
                        <evaluations-table :onLoaded="echoName" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import EvaluationsTable from '@/components/tables/evaluations/EvaluationsTable';

    @Component({
        components: {
            EvaluationsTable,
        }
    })
    export default class Evaluations extends Vue {
        name = 'evaluations';
        studentName = 'Loading...';

        echoName(name) {
            this.studentName = name;
        }
    }

    Vue.component('evaluations', Evaluations);
</script>



// WEBPACK FOOTER //
// src/pages/Evaluations.vue